module.exports = __webpack_public_path__ + "static/img/page7.b70c679.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/page7.jpg
// module id = p//5
// module chunks = 0